export const ICON_BUTTON_SIZE_MAP = {
    big: '40px',
    default: '32px',
};
